// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"ClientWallet_footerContainer__xoyOL","savePackageButton":"ClientWallet_savePackageButton__2cHoU"};